module.exports = __webpack_public_path__ + "static/media/product_dem.39233419.jpg";